import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./common/PrivateRoute";
import "react-phone-number-input/style.css";

import Login from "./components/Login";
import Register from "./components/Registration";
import LandingPage from "./components/LandingPage";
import Dashboard from "./pages/Dashboard/Dashboard";
import ForgotPasswordPage from "./components/ForgotPasswordPage"
import ScrollToTop from "./components/ScrollToTop";

const PlanSet = lazy(() => import("./pages/Planset/PlansetMain/PlanSet"));
const PlansetOrder = lazy(() => import("./pages/Planset/CreatePlanset/PlansetOrder"));
const PlansetView = lazy(() => import("./pages/Planset/ViewPlanset/PlansetView"));
const TeamMain = lazy(() => import("./pages/Team/TeamMain/TeamMain"));
const ClientMain = lazy(() => import("./pages/Clients/ClientMain/ClientMain"));
const PEStamp = lazy(() => import("./pages/PEStamp/PEStampMain/PEStamp"));
const PEStampView = lazy(() => import("./pages/PEStamp/ViewPEStamp/PEStampView"));
const PEStampOrder = lazy(() => import("./pages/PEStamp/CreatePEStamp/PEStampOrder"));
const SalesProposal = lazy(() => import("./pages/SalesProposal/SalesProposalMain/SalesProposal"));
const SalesProposalView = lazy(() => import("./pages/SalesProposal/ViewSalesProposal/SalesProposalView"));
const SalesProposalOrder = lazy(() => import("./pages/SalesProposal/CreateSalesProposal/SalesProposalOrder"));
const PTO = lazy(() => import("./pages/PTO/PTOMain/PTO"));
const PTOOrder = lazy(() => import("./pages/PTO/CreatePTO/PTOOrder"));
const PTOView = lazy(() => import("./pages/PTO/ViewPTO/PTOView"));
const StampingPartners = lazy(() => import("./pages/StampingPartners/StampingPartners"));
const Archive = lazy(() => import("./pages/Archive/Archive"));
const Chats = lazy(() => import("./pages/Chats/Chats"));
const About = lazy(() => import("./pages/About/About"));
const ReviewWithAI = lazy(() => import("./pages/ReviewWithAI/ReviewWithAI"));
const Verification = lazy(() => import("./pages/Verification/Verification"));



function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Suspense fallback={<div className="app-loading">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verification" element={<Verification />} />
          <Route path="/forgotpassword/:token?" element={<ForgotPasswordPage />} />
          <Route element={<PrivateRoute><LandingPage /></PrivateRoute>}>
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/salesproposal" element={<PrivateRoute><SalesProposal /></PrivateRoute>} />
            <Route path="/salesproposal/view" element={<PrivateRoute><SalesProposalView /></PrivateRoute>} />
            <Route path="/salesproposal/order" element={ <PrivateRoute> <SalesProposalOrder /> </PrivateRoute> }/>
            <Route path="/pestamp" element={<PrivateRoute><PEStamp /></PrivateRoute>} />
            <Route path="/pestamp/view" element={<PrivateRoute><PEStampView /></PrivateRoute>} />
            <Route path="/pestamp/order" element={<PrivateRoute><PEStampOrder /></PrivateRoute>} />
            <Route path="/pto" element={<PrivateRoute><PTO /></PrivateRoute>} />
            <Route path="/pto/order" element={<PrivateRoute><PTOOrder /></PrivateRoute>} />
            <Route path="/pto/view" element={<PrivateRoute><PTOView /></PrivateRoute>} />
            <Route path="/chats" element={<PrivateRoute><Chats /></PrivateRoute>} />
            <Route path="/archive" element={<PrivateRoute><Archive /></PrivateRoute>} />
            <Route path="/stampingpartners" element={<PrivateRoute><StampingPartners /></PrivateRoute>} />
            <Route path="/planset" element={<PrivateRoute><PlanSet /></PrivateRoute>} />
            <Route path="/planset/order" element={<PrivateRoute><PlansetOrder /></PrivateRoute>} />
            <Route path="/planset/view" element={<PrivateRoute><PlansetView /></PrivateRoute>} />
            <Route path="/team" element={<PrivateRoute><TeamMain /></PrivateRoute>} />
            <Route path="/clients" element={<PrivateRoute><ClientMain /></PrivateRoute>} />
            <Route path="/about" element={<PrivateRoute><About /></PrivateRoute>} />
            <Route path="/reviewwithai" element={<PrivateRoute><ReviewWithAI/></PrivateRoute>} />
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
